import { setDiagramVisualizer } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
export type Props = ApiMethodBase & {}

export const processDiscoveryRuleUpdateDiagram = ({
    eventEmitter,
}: Props) => {
    eventEmitter.emit(Event.processDiscoveryRule);
    setDiagramVisualizer()
    eventEmitter.emit(Event.updateGaugeMetrics);
};

